import I18nForLwText from './LwText'

export default class I18nForLwTimestamp extends I18nForLwText {
  name = 'lw-timestamp'
}
